import config from "@/config";

const SCRIPT_ID = "zsiqscript";
const SCRIPT_BASE_URL = "https://salesiq.zohopublic.com/widget?wc=";

function getZohoConfig() {
  const zoho = config.zoho || {};
  return {
    enabled: zoho.salesIQEnabled !== false,
    widgetCode: zoho.salesIQWidgetCode || "",
  };
}

function initZohoGlobal() {
  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || {};

  const previousReady =
    typeof window.$zoho.salesiq.ready === "function"
      ? window.$zoho.salesiq.ready
      : function () {};

  window.$zoho.salesiq.ready = function () {
    previousReady();
    if (typeof window.__eclockZohoFlushVisitor === "function") {
      window.__eclockZohoFlushVisitor();
    }
  };
}

function mapVisitorFromPerfil(perfil) {
  const usuario = (perfil && perfil.usuario) || {};
  return {
    name: usuario.nombre || "",
    email: usuario.correo || "",
    contactnumber: usuario.telefono || "",
    phone: usuario.telefono || "",
    id: usuario.usuarioID != null ? `${usuario.usuarioID}` : "",
  };
}

function splitName(fullName) {
  if (!fullName) {
    return { firstname: "", lastname: "", salutation: "None" };
  }
  const parts = `${fullName}`.trim().split(/\s+/).filter(Boolean);
  if (parts.length < 2) {
    return { firstname: parts[0] || "", lastname: "", salutation: "None" };
  }
  return {
    firstname: parts[0],
    lastname: parts.slice(1).join(" "),
    salutation: "None",
  };
}

function isRuntimeVisitorApi(visitorApi) {
  if (!visitorApi) return false;
  return (
    typeof visitorApi.name === "function" ||
    typeof visitorApi.email === "function" ||
    typeof visitorApi.contactnumber === "function"
  );
}

function applyVisitorRuntime(salesiq, visitorData) {
  if (!salesiq || !isRuntimeVisitorApi(salesiq.visitor)) return false;

  const nameInfo = splitName(visitorData.name);
  if (typeof salesiq.visitor.name === "function") {
    salesiq.visitor.name(nameInfo);
  }
  if (visitorData.email && typeof salesiq.visitor.email === "function") {
    salesiq.visitor.email(visitorData.email);
  }
  if (
    visitorData.contactnumber &&
    typeof salesiq.visitor.contactnumber === "function"
  ) {
    salesiq.visitor.contactnumber(visitorData.contactnumber);
  }
  if (visitorData.id && typeof salesiq.visitor.id === "function") {
    salesiq.visitor.id(visitorData.id);
  }
  return true;
}

const ZohoSalesIQService = {
  loaded: false,
  loading: false,
  pendingVisitor: null,

  load() {
    const cfg = getZohoConfig();
    if (!cfg.enabled || !cfg.widgetCode) return Promise.resolve(false);

    initZohoGlobal();

    const existingScript = document.getElementById(SCRIPT_ID);
    if (existingScript) {
      this.loaded = true;
      return Promise.resolve(true);
    }

    if (this.loading) return Promise.resolve(false);
    this.loading = true;

    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src = `${SCRIPT_BASE_URL}${cfg.widgetCode}`;
      script.defer = true;
      script.onload = () => {
        this.loaded = true;
        this.loading = false;
        resolve(true);
      };
      script.onerror = () => {
        this.loading = false;
        resolve(false);
      };
      document.body.appendChild(script);
    });
  },

  setVisitor(visitor) {
    initZohoGlobal();

    this.pendingVisitor = {
      ...(this.pendingVisitor || {}),
      ...visitor,
    };

    const salesiq = window.$zoho.salesiq;
    applyVisitorRuntime(salesiq, this.pendingVisitor);
  },

  setVisitorFromPerfil(perfil) {
    const visitor = mapVisitorFromPerfil(perfil);
    this.setVisitor(visitor);
  },

  clearVisitor() {
    initZohoGlobal();
    this.pendingVisitor = null;

    const salesiq = window.$zoho.salesiq;
    if (typeof salesiq.reset === "function") {
      salesiq.reset();
      return;
    }
    if (isRuntimeVisitorApi(salesiq.visitor)) {
      if (typeof salesiq.visitor.name === "function") {
        salesiq.visitor.name({ firstname: "", lastname: "", salutation: "None" });
      }
      if (typeof salesiq.visitor.email === "function") salesiq.visitor.email("");
      if (typeof salesiq.visitor.contactnumber === "function")
        salesiq.visitor.contactnumber("");
      if (typeof salesiq.visitor.id === "function") salesiq.visitor.id("");
      return;
    }

    salesiq.visitor = {};
  },

  flushVisitor() {
    if (!this.pendingVisitor) return;
    const salesiq = window.$zoho && window.$zoho.salesiq;
    applyVisitorRuntime(salesiq, this.pendingVisitor);
  },
};

export default {
  install(Vue) {
    window.__eclockZohoFlushVisitor = () => ZohoSalesIQService.flushVisitor();
    Vue.prototype.$zohoSalesIQ = ZohoSalesIQService;
  },
};
